export default function getDefaultOutlookThemeColor() {
    return '#0078D4';
}
